export const SERVICE_CATEGORY_INDIVIDUAL = "individual";
export const SERVICE_CATEGORY_BUSINESS = "business";

export const SERVICE_CATEGORY_OPTIONS = [
  { id: SERVICE_CATEGORY_INDIVIDUAL, value: "Individual" },
  { id: SERVICE_CATEGORY_BUSINESS, value: "Business" },
];

export const INDIVIDUAL_SERVICE_NAME_OPTIONS = [
  { id: "Individual Tax Filing", value: "Individual Tax Filing" },
  {
    id: "Individual and Sole proprietorship Tax Filing",
    value: "Individual and Sole proprietorship Tax Filing",
  },
  {
    id: "Tax Planning and Consultation",
    value: "Tax Planning and Consultation",
  },
  { id: "Custom", value: "Custom" },
];

export const BUSINESS_SERVICE_NAME_OPTIONS = [
  { id: "LLC/Partnership Tax Filing", value: "LLC/Partnership Tax Filing" },
  { id: "S-Corp Tax filing", value: "S-Corp Tax filing" },
  { id: "C Corporation Tax Filing", value: "C Corporation Tax Filing" },
  { id: "Non-Profit Tax Filing", value: "Non-Profit Tax Filing" },
  { id: "Bookkeeping Services", value: "Bookkeeping Services" },
  { id: "Payroll Services", value: "Payroll Services" },
  { id: "Custom", value: "Custom" },
];

const SERVICE_TAX_YEAR_START = 2020;

export const SERVICE_TAX_YEAR_OPTIONS = (() => {
  const endYear = new Date().getFullYear() + 1;
  const options = [];
  for (let year = SERVICE_TAX_YEAR_START; year <= endYear; year += 1) {
    const value = String(year);
    options.push({ id: value, value });
  }
  return options;
})();

export const SERVICE_FREQUENCY_OPTIONS = [
  { id: "Onetime/Annual", value: "Onetime/Annual" },
  { id: "Quarterly", value: "Quarterly" },
  { id: "Monthly", value: "Monthly" },
];

export function getServiceNameOptionsForCategory(category) {
  const normalized = String(category || "").trim().toLowerCase();
  return normalized === SERVICE_CATEGORY_BUSINESS
    ? BUSINESS_SERVICE_NAME_OPTIONS
    : INDIVIDUAL_SERVICE_NAME_OPTIONS;
}

export function getServiceCategoryLabel(category) {
  return String(category || "").trim().toLowerCase() === SERVICE_CATEGORY_BUSINESS
    ? "Business"
    : "Individual";
}

export const SERVICE_DEFAULT_STATUS = "Ongoing";
export const SERVICE_COMPLETED_STATUS = "Completed";

export const SERVICE_STATUS_OPTIONS = [
  { id: SERVICE_DEFAULT_STATUS, value: "Ongoing" },
  { id: SERVICE_COMPLETED_STATUS, value: "Completed" },
];

export function normalizeServiceStatus(status) {
  const raw = String(status || "").trim().toLowerCase();
  if (raw === "completed" || raw === "closed") {
    return SERVICE_COMPLETED_STATUS;
  }
  return SERVICE_DEFAULT_STATUS;
}

export function getClientServiceRecordId(service) {
  const id = service?.client_service_id ?? service?.id ?? service?.service_id;
  return id == null || id === "" ? "" : String(id);
}

export function formatClientServiceDropdownOption(service) {
  const id = getClientServiceRecordId(service);
  if (!id) return null;
  const name = service?.service_name || service?.serviceName || "Service";
  const taxYear = service?.tax_year || service?.taxYear;
  const frequency = service?.service_frequency || service?.serviceFrequency;
  const parts = [name];
  if (taxYear) parts.push(String(taxYear));
  if (frequency) parts.push(String(frequency));
  return { id, value: parts.join(" · ") };
}

export function buildClientServiceDropdownOptions(services = []) {
  const placeholder = { id: "", value: "Select service", keepAtTop: true };
  const options = (services || [])
    .map(formatClientServiceDropdownOption)
    .filter(Boolean);
  return [placeholder, ...options];
}

export function formatServiceStatus(status) {
  return normalizeServiceStatus(status);
}

export function getServiceClientBusinessId(service) {
  const id =
    service?.client_business_id ??
    service?.clientBusinessId ??
    service?.business_id ??
    service?.businessId;
  return id == null || id === "" ? "" : String(id);
}

export function getServiceBusinessName(service, businesses = []) {
  const direct = String(
    service?.business_name || service?.businessName || "",
  ).trim();
  if (direct) return direct;
  const businessId = getServiceClientBusinessId(service);
  if (!businessId) return "—";
  const match = (businesses || []).find(
    (business) =>
      String(business?.client_business_id || business?.id || "") === businessId,
  );
  const name = String(match?.business_name || match?.businessName || "").trim();
  return name || "—";
}

export function buildClientBusinessDropdownOptions(businesses = []) {
  return (businesses || [])
    .map((business) => {
      const id = String(
        business?.client_business_id ?? business?.id ?? "",
      ).trim();
      const name = String(
        business?.business_name || business?.businessName || "",
      ).trim();
      if (!id || !name) return null;
      return {
        id,
        value: business?.is_primary ? `${name} (Primary)` : name,
      };
    })
    .filter(Boolean);
}
